import { UnionWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Union')
export class UnionConnectorProvider extends ConnectorProvider<UnionWorkflowNode> {}
